import {Component, Input, OnInit} from '@angular/core';
import {AdminService} from "../../../../../core/services/AdminService";
import {PopoverController, ToastController} from "@ionic/angular";
import {SelectBarComponent} from "../../select-bar/select-bar.component";

@Component({
    selector: 'app-html-editor',
    templateUrl: './html-editor.component.html',
    styleUrls: ['./html-editor.component.scss'],
})
export class HtmlEditorComponent implements OnInit {

    @Input()
    exTableData;
    @Input()
    sectionName;
    @Input()
    model;
    @Input()
    fieldData;
    @Input()
    fieldType;

    fieldsType;
    saveInterval;

    //selectTable templte/field choose
    selectTableType = 'field';
    templateModel;

    //current field to be choose / copy
    currentField;

    constructor(private adminService: AdminService, private toastCtrl: ToastController, private popoverCtrl: PopoverController) {
    }

    ngOnInit() {
        this.fieldsType = this.adminService.getFieldsType(this.sectionName, this.exTableData);
    }

    save() {
        ////console.log'save');
        ////console.logthis.fieldData.value);

        clearTimeout(this.saveInterval);

        this.fieldData['fieldSaveWait'] = true;
        this.fieldData['validate'] = true;

        let me = this;
        this.saveInterval = setTimeout(function () {

            me.adminService.saveField(me.sectionName, me.model, me.fieldData, me.fieldType);

            me.fieldData['editMode'] = false;
        }, 5000);
    }

    addField(fieldType, extraData = []) {
        this.currentField = fieldType;

        //this types require more data.
        if (['table', 'selectTable'].indexOf(this.currentField.type) != -1 && extraData.length == 0) {
            return;
        }

        let val;

        // if (fieldType['type'] == 'table') {
        //     val = "{" + fieldType['name'];// + "|template|filter|sort|num";
        // } else if (fieldType['type'] == 'selectTable') {
        //     val = "{" + fieldType['name']; //|type|fieldName // type-template/field
        // } else {
        val = fieldType['name'];
        // }

        ////console.logextraData);

        for (let key of extraData) {
            val += '/' + key;
        }
        val = "{" + val + "}";

        this.copyToCliporad(val);
    }

    async copyToCliporad(val) {

        this.fieldData.value += val;
        this.save();
        return;

        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);

        //     showCloseButton: true,
        //     closeButtonText: 'OK',
        let toast = await this.toastCtrl.create({
            message: val + " - Copied to clipboard.",
            duration: 1000,
            position: 'bottom',
        });
        toast.present();


        // toast.present();
    }

    //select table
    //select table template
    async presentSelectBar(myEvent, modelName, fieldName) {
        this.fieldData['modelId'] = 1;
        this.fieldData['mainDisplayName'] = 'Template';

        let sectionName = 'chooseTemplate';

        this.exTableData[sectionName + 'Ref'] = [
            {'type': 'number', 'name': 'id'},
            {'type': 'selectTable', 'name': 'template', 'model': 'form'},
            {'type': 'selectTable', 'name': 'filter', 'model': 'appFilter'}
        ];
        this.exTableData[sectionName + 'Data'] = {'title': sectionName};

        //to global
        this.adminService.manageModels['chooseTemplateData'] = this.exTableData[sectionName + 'Data'];
        this.adminService.manageModels[sectionName + 'Ref'] = this.exTableData[sectionName + 'Ref'];

        if (!this.templateModel) {
            this.templateModel = {'template': {'value': null}, 'filter': {'value': null}};
        }

        if (this.currentField) {
            this.templateModel['filter']['baseFilter'] = this.templateModel['template']['baseFilter'] = {
                'searchFieldValue': this.currentField['model'],
                'searchField': 'contentType__model',
                'search_in_field': true
            };
        }

        const popover = await this.popoverCtrl.create({
            component: SelectBarComponent,
            componentProps: {
                'model': this.templateModel, // if search by id so dont send model - it will query it from server
                'prefix': "Aaa",
                'avoidSave': true,
                'fieldData': this.templateModel[fieldName],
                'fieldType': {'type': 'selectTable', 'model': modelName},
                'exTableData': this.exTableData,
                'sectionName': sectionName,
                'type': 'selectTable'
            },
            event: myEvent,
            animated: true,
            showBackdrop: true,
            cssClass: 'note-popover icenter-popover smaller-popover'
        });

        //right-popup
        await popover.present();
    }
}
